module.exports = __webpack_public_path__ + "164db33c3d5c8e1fcf4d94b65b0da148.svg";